import React from "react";
import Subscriber from "../../subscriber.class";
import Storage from "../../services/storage.service";
import {getStepStyleByPath, getStepOrderByPath, getRouteObsrv} from "../../services/flow.service";

export default class BodyClasses extends Subscriber {
  state = {
    modal_open: false,
    step: 0,
    variation: 'vmo-plain-header'
  };

  componentDidMount() {

    this.subscriptions.push(
      Storage.get_obsrv("modal_open").subscribe((modal_type) => {
        this.setState({
          modal_open: modal_type,
        });
      })
    );

    getRouteObsrv().subscribe((data) => {
      this.setState({
        variation: getStepStyleByPath(data),
        order: getStepOrderByPath(data),
      });
    });
  }

  render() {

    let classes = [];
    if (this.state.modal_open) {
      classes.push("vmo-bc-modal vmo-bc-modal-" + this.state.modal_open);
    }

    classes.push(this.state.variation);
    classes.push("testing-bb-" + this.state.order);
    classes.push("vmo-bb-page-" + this.state.order);

    return <div className={"vmo-bc " + classes.join(" ")} />;
  }
}
